import { render, staticRenderFns } from "./ProductManagement.vue?vue&type=template&id=0bb72f15&"
import script from "./ProductManagement.vue?vue&type=script&lang=js&"
export * from "./ProductManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProductManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports